import item1 from '../assets/jobs/item1.svg';
import item2 from '../assets/jobs/item2.svg';
import item3 from '../assets/jobs/item3.svg';
import item4 from '../assets/jobs/item4.svg';

import { getContent } from '../store/ContentStore';

const ICON_MAP = {
    item1: item1,
    item2: item2,
    item3: item3,
    item4: item4,
};

const MAX_JOBS_ITEMS = Object.keys(ICON_MAP).length; 

export const loadJobsContentEn = () => {
    const jobsData = getContent("jobs.", "en");

    if (!jobsData || !jobsData.en || Object.keys(jobsData.en).length === 0) {
        return { title: '', description: '', jobs: [] };
    }
    
    const englishLabels = jobsData.en; 
   
    const mainTitle = englishLabels['jobs.title'] || 'Default Jobs Title';
    const mainDescription = englishLabels['jobs.description'] || 'Default Jobs Description';

    const jobsArray = [];

    for (let i = 1; i <= MAX_JOBS_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `jobs.${itemKey}.title`;
        const descriptionKey = `jobs.${itemKey}.description`;
        
        const heading = englishLabels[headingKey];
        const description = englishLabels[descriptionKey];
        const icon = ICON_MAP[itemKey];

        if (heading && description && icon) {
            jobsArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        description: mainDescription,
        jobs: jobsArray,
    };
};


export const loadJobsContentRo = () => {
    const jobsData = getContent("jobs.", "ro");

    if (!jobsData || !jobsData.ro || Object.keys(jobsData.ro).length === 0) {
        return { title: '', description: '', jobs: [] };
    }
    
    const romanianLabels = jobsData.ro; 
   
    const mainTitle = romanianLabels['jobs.title'] || 'Default Jobs Title';
    const mainDescription = romanianLabels['jobs.description'] || 'Default Jobs Description';

    const jobsArray = [];

    for (let i = 1; i <= MAX_JOBS_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `jobs.${itemKey}.title`;
        const descriptionKey = `jobs.${itemKey}.description`;
        
        const heading = romanianLabels[headingKey];
        const description = romanianLabels[descriptionKey];
        const icon = ICON_MAP[itemKey];

        if (heading && description && icon) {
            jobsArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        description: mainDescription,
        jobs: jobsArray,
    };
};